import { useCallback, useContext, useMemo, useState } from "react";
import { WalletAPIProviderContext } from "../components/WalletAPIProvider/context";
const initialState = {
    pending: false,
    account: null,
    error: null,
};
export function useRequestAccount() {
    const { client } = useContext(WalletAPIProviderContext);
    const [state, setState] = useState(initialState);
    const requestAccount = useCallback(async (...params) => {
        try {
            setState((oldState) => ({
                ...oldState,
                pending: true,
                error: null,
            }));
            if (!client) {
                throw new Error("WalletAPIClient is not initialised");
            }
            const account = await client.account.request(...params);
            setState((oldState) => ({
                ...oldState,
                pending: false,
                account,
            }));
        }
        catch (error) {
            setState((oldState) => ({
                ...oldState,
                pending: false,
                error,
            }));
        }
    }, [client]);
    const result = useMemo(() => ({
        requestAccount,
        ...state,
    }), [requestAccount, state]);
    return result;
}
//# sourceMappingURL=useRequestAccount.js.map